export default __webpack_public_path__ + "static/media/Erica_Peña-Vest_AHV_In_Moms_We_Trust.6de9975f.jpg";